import * as Actions from 'reducks/modal/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const ModalReducer = (state = initialState.modal, action: any) => {
  switch (action.type) {
    case Actions.CLOSE_CONFIRM_MODAL:
      return {
        ...state,
        confirm: {
          ...state.confirm,
          open: action.payload.confirm,
        },
      }
    case Actions.CLOSE_MODAL:
      return {
        ...initialState.modal,
      }
    case Actions.CLOSE_CAUTION_MODAL:
      return {
        ...state,
        caution: {
          ...initialState.modal.caution,
        },
      }
    case Actions.CLOSE_SHARED_BREAD_MODAL:
      return {
        ...state,
        shared_bread: { ...action.payload },
      }
    case Actions.CLOSE_STAFF_MODAL:
      return {
        ...state,
        staff: { ...action.payload },
      }
    case Actions.CLOSE_STOCK_MODAL:
      return {
        ...state,
        stock: { ...action.payload },
      }
    case Actions.CLOSE_STORE_SWITCH_MODAL:
      return {
        ...state,
        store: { ...action.payload },
      }
    case Actions.EDIT_CONTENT:
      return {
        ...state,
        edited: action.payload,
      }
    case Actions.EDIT_STOCK_CONTENT:
      return {
        ...state,
        stock: {
          ...state.stock,
          edited: action.payload,
        },
      }
    case Actions.INIT_EDIT_CONTENT:
      return {
        ...state,
        edited: action.payload,
      }
    case Actions.OPEN_MODAL:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.OPEN_BULK_STOCK_MODAL:
      return {
        ...state,
        bulk_stock: {
          ...action.payload,
        },
      }
    case Actions.OPEN_CAUTION_MODAL:
      return {
        ...state,
        caution: { ...action.payload },
      }
    case Actions.OPEN_CONFIRM_MODAL:
      return {
        ...state,
        confirm: {
          ...state.confirm,
          open: action.payload.confirm,
        },
      }
    case Actions.OPEN_SHARED_BREAD_MODAL:
      return {
        ...state,
        shared_bread: { ...action.payload },
      }
    case Actions.OPEN_STAFF_MODAL:
      return {
        ...state,
        staff: { ...action.payload },
      }
    case Actions.OPEN_STOCK_MODAL:
      return {
        ...state,
        stock: { ...action.payload },
      }
    case Actions.OPEN_STORE_SWITCH_MODAL:
      return {
        ...state,
        store: { ...action.payload },
      }
    case Actions.SET_ERROR:
      return {
        ...state,
        error: action.payload.error,
      }
    case Actions.UPDATE_MODAL_HEADER:
      return {
        ...state,
        description: action.payload.description,
        title: action.payload.title,
      }
    default:
      return state
  }
}
